
import React, { Fragment, useState } from 'react'
import {AppButton,AppRow,AppGridBar,AppForm,AppGridTabs, AppTable,AppAction} from 'qcc'
import { Row, Icon ,Col} from 'antd';
import api, {BankInfo} from 'api';
import {PosApiInputBar} from '../components/PosApiInputBar'
import {PosApiInputContent} from '../components/PosApiInputContent'

let inputConfig = {
    example : "P0231",
    formdata:{AOXM:''},
    labelWidth:100 ,
    items:
    [
        {lable:'项目',field:'AOXM',placeholder:'string类型:一级项目的ID'}
    ]
};

let outputExample = [
    {
        aofq:'分期',
	aold:'楼栋',
	aoxm:'项目',
	bankl:'银行代码',
	bankn:'银行帐户号码',
	db_KEY:'表主键',
	fund_CODE:'款项编码',
	fund_TYPE:'款项类型',
	hbkid:'开户银行的简要键',
	hktid:'帐户细目的代码',
	zbanka:'银行名称'
    }
 ] as BankInfo[]

export const SapGetBank = () =>{

    const[outputResult,setOutputResult]  = useState([] as BankInfo[])
    const[outputView,setOutputView]  = useState(0)

    const execApi = async () =>{
        let inputParam = refPosApiInputContent.current.getFormData();
        AppAction.coverFull();
        let res = await api.public.possap.getBankInfoList(inputParam);
        setOutputResult(res);
        AppAction.cancelCoverFull();
    }

    const renderOutput = () =>{
        console.log('outputResult:',outputResult)
        if(outputResult===null) return '';

        switch(outputView){
            case 0:
            return <RoomTable list={outputResult}/>;
        }

        return  <pre>{JSON.stringify(outputResult, null, 4)}</pre>;
    }
    
    let refPosApiInputContent = React.createRef<PosApiInputContent>();
    return (<div className='app-demo-content'>
            <h1>SAP获取入帐银行</h1>    
            <div>
                1、调用SAP接口获取SAP入帐银行<br/>
                2、参数为一级项目id（POSID） <br/>
            </div>

            <div className='app-pos-api-input'>
                <PosApiInputBar  fn={execApi}/>
                <div className='app-pos-api-input-line'/>
                <PosApiInputContent ref={refPosApiInputContent} config={inputConfig} />
            </div>

            <div className='app-pos-api-input'>
                <AppGridBar>
                    <AppGridBar.Left>
                        <AppGridTabs defaultTabIndex={outputView} 
                        onChange={(tabIndex)=>{setOutputView(tabIndex)}} 
                        tabs={['列表','JSON']}/>
                    </AppGridBar.Left>
                </AppGridBar>
                <div className='app-pos-api-input-line'/>
                <Row className='app-pos-api-input-content'>
                    <Col span={16} className='app-pos-api-input-form'>
                        {renderOutput()}
                    </Col>
                    <Col span={8} className='app-pos-api-input-example'>
                        <div>示例：</div>
                        <pre>{JSON.stringify(outputExample, null, 4)}</pre>
                    </Col>
                </Row>

            </div>
    </div>)
}


const RoomTable = (props:{list:any[]}) =>{
    return ( <AppTable  dataSource={props.list}>
        <AppTable.ColIndex />
        <AppTable.Col field='db_KEY' title='表主键'  width={100}/>
        <AppTable.Col field='zbanka' title='银行名称' width={100}/>
        <AppTable.Col field='bankn' title='银行帐户号码' width={100}/>
        <AppTable.Col field='bankl' title='银行代码' width={100}/>
        <AppTable.Col field='aoxm' title='项目'  width={100}/>
        <AppTable.Col field='aofq' title='分期' width={100}/>
        <AppTable.Col field='aold' title='楼栋' width={100}/>
        <AppTable.Col field='fund_CODE' title='款项编码' width={100}/>
        <AppTable.Col field='fund_TYPE' title='款项类型' width={100}/>
        <AppTable.Col field='hbkid' title='开户银行的简要键' width={100}/>
        <AppTable.Col field='hktid' title='帐户细目的代码' width={100}/>
     </AppTable>)
}



// WEBPACK FOOTER //
// ./src/posapi/sap/SapGetBank.tsx